import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'
import useSWR from 'swr'

import {fetcher} from '../../../../../api'
import {camelizeResult, dineroMoneyObjects} from '../../../../../api/serializer'
import Loading from '../../../../components/Loading'

import SummaryTotal from './SummaryTotal'

const Summary = ({payerId, status, currentTab}) => {
  const {t} = useTranslation('payerStatements')

  const {data, isLoading} = useSWR(
    `/api/payer_statements/customers/${payerId}/summary?status=${status}`,
    fetcher,
    {
      use: [camelizeResult, dineroMoneyObjects],
      suspense: true,
      fallbackData: {
        summary: {
          amount: {
            cents: 0,
            currency: 'AUD',
          },
          count: 0,
        },
      },
    },
  )

  const {amount, count} = data.summary

  return (
    <Loading>
      <Box
        backgroundColor="mld.neutral.200"
        p="md"
        mt="md"
        mb="md"
        borderColor="mld.neutral.500"
        borderWidth="1px"
        borderRadius="4px"
      >
        <Text>{t(`summary.headings.${currentTab}`)}</Text>
        <SummaryTotal amount={amount} isLoading={isLoading} />
        <Text
          as="span"
          borderRadius="25px"
          textStyle="caption"
          backgroundColor="mld.neutral.0"
          pl="xs"
          pr="xs"
        >
          <Trans t={t} i18nKey="summary.count" values={{count}} />
        </Text>
      </Box>
    </Loading>
  )
}

Summary.propTypes = {
  payerId: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  currentTab: PropTypes.string.isRequired,
}

export default Summary
